/**
 * Keep the novelty-gift app widget in the cart, not as a bottom popup.
 * Cart HTML remorphs can detach the element; salvage it and put it back
 * into [data-gltheaa-novelty-slot].
 */
(function () {
  if (window.__gltheaaNoveltyGiftSlot) return;
  window.__gltheaaNoveltyGiftSlot = true;

  const HOST = "novelty-gift";
  const SLOT = "[data-gltheaa-novelty-slot]";
  const PARKING_ID = "gltheaa-novelty-parking";

  function parking() {
    let node = document.getElementById(PARKING_ID);
    if (!node) {
      node = document.createElement("div");
      node.id = PARKING_ID;
      node.hidden = true;
      document.body.appendChild(node);
    }
    return node;
  }

  function hostEl() {
    return document.querySelector(HOST);
  }

  function isHostOrContainsHost(node) {
    return (
      node instanceof Element && (node.matches(HOST) || Boolean(node.querySelector(HOST)))
    );
  }

  function isSlotOrContainsSlot(node) {
    return (
      node instanceof Element &&
      (node.matches(SLOT) || Boolean(node.querySelector(SLOT)))
    );
  }

  function pickSlot() {
    const drawer = document.querySelector("cart-drawer");
    const drawerSlot = document.querySelector("cart-drawer " + SLOT);
    const pageSlot = document.querySelector("#main-cart-footer " + SLOT);
    if (drawer && drawer.classList.contains("active") && drawerSlot) return drawerSlot;
    if (pageSlot && !drawer?.classList.contains("active")) return pageSlot;
    return drawerSlot || pageSlot;
  }

  function salvage(node) {
    if (!(node instanceof Element)) return false;
    const el = node.matches(HOST) ? node : node.querySelector(HOST);
    if (!el) return false;
    if (el.isConnected && (el.closest(SLOT) || el.parentElement === parking())) return false;
    parking().appendChild(el);
    return true;
  }

  function isDefaultVariantTitle(value) {
    return /^default title$/i.test((value || "").trim());
  }

  function captionLabel(text, hasImage) {
    const value = (text || "").trim();
    const parts = value.split(" / ").map((part) => part.trim()).filter(Boolean);
    if (!parts.length) return "";

    const product = parts[0];
    const variant = parts.length > 1 ? parts[parts.length - 1] : "";
    const variantIsDefault = !variant || isDefaultVariantTitle(variant);

    if (variantIsDefault) return isDefaultVariantTitle(product) ? "" : product;
    if (!hasImage) return product === variant ? product : `${product} / ${variant}`;
    return variant;
  }

  function fitOpenAddon(el) {
    const openAddon = el.closest("[data-gltheaa-cart-addon][open]");
    if (!openAddon || openAddon.dataset.gltheaaAnimating === "true") return;
    const panel = openAddon.querySelector(":scope > .gltheaa-cart-addon__content");
    if (panel) panel.style.height = "auto";
  }

  function noticeLabel(el) {
    const parts = [];
    el.querySelectorAll(".novelty-gift__campaign").forEach((campaign) => {
      campaign.querySelectorAll(":scope > .novelty-gift__message").forEach((message) => {
        const hiddenByTheme = message.dataset.gltheaaNoticeHidden === "true";
        if (message.hidden && !hiddenByTheme) return;
        const text = (message.textContent || "").replace(/\s+/g, " ").trim();
        if (text && !parts.includes(text)) parts.push(text);
        message.hidden = true;
        message.dataset.gltheaaNoticeHidden = "true";
      });
    });
    return parts.join("\n");
  }

  function updateNoveltyStatus(el) {
    const label = noticeLabel(el);
    const activeAddon = el.closest("[data-gltheaa-cart-addon]");
    document.querySelectorAll("[data-gltheaa-novelty-status]").forEach((status) => {
      const active = Boolean(activeAddon && status.closest("[data-gltheaa-cart-addon]") === activeAddon);
      status.textContent = active ? label : "";
      status.hidden = !active || !label;
    });
  }

  let expandArmed = true;

  function expandCollapsedPickers(el) {
    if (!expandArmed) return;
    const buttons = Array.from(el.querySelectorAll("[data-change-button]")).filter((node) => !node.disabled);
    if (!buttons.length) return;
    expandArmed = false;
    buttons.forEach((button) => {
      if (button.isConnected) button.click();
    });
  }

  function polishAddonCampaigns(el) {
    el.querySelectorAll(".novelty-gift__campaign").forEach((campaign) => {
      const heading = campaign.querySelector(".novelty-gift__heading");
      const hasPicker = Boolean(campaign.querySelector(".novelty-gift__option"));
      if (heading) heading.hidden = hasPicker;
      campaign.querySelectorAll(".novelty-gift__option, .novelty-gift__heading").forEach((option) => {
        if (option.matches(".novelty-gift__option")) option.hidden = false;
        const caption = option.querySelector(
          ".novelty-gift__visually-hidden, .novelty-gift__option-label"
        );
        if (!caption || caption.dataset.gltheaaCaptioned === "true") return;
        caption.dataset.gltheaaCaptioned = "true";
        const hasImage = Boolean(option.querySelector(".novelty-gift__option-image"));
        caption.textContent = captionLabel(caption.textContent, hasImage);
        caption.classList.add("novelty-gift__option-caption");
      });
    });
  }

  function syncNoveltyAddonVisibility() {
    const el = hostEl();
    const visible = Boolean(el && el.hasAttribute("data-visible"));
    document.querySelectorAll('[data-gltheaa-cart-addon="novelty"]').forEach((addon) => {
      if (!(addon instanceof HTMLElement)) return;
      addon.hidden = !visible;
      if (visible) return;
      addon.removeAttribute("open");
      const panel = addon.querySelector(":scope > .gltheaa-cart-addon__content");
      if (panel) panel.style.height = "";
    });
  }

  function enhance(el) {
    if (!(el instanceof HTMLElement)) return;
    syncNoveltyAddonVisibility();
    const slot = el.closest(SLOT);
    const selectLabel = slot?.dataset.selectLabel || "";

    if (el.closest("[data-gltheaa-cart-addon]")) {
      el.querySelectorAll("[data-gltheaa-novelty-select]").forEach((button) => button.remove());
      expandCollapsedPickers(el);
      polishAddonCampaigns(el);
      updateNoveltyStatus(el);
      fitOpenAddon(el);
      return;
    }

    el.querySelectorAll(".novelty-gift__campaign").forEach((campaign) => {
      const options = campaign.querySelectorAll(".novelty-gift__option");
      const changeButton = campaign.querySelector("[data-change-button]");
      if (!options.length || changeButton) return;
      if (campaign.querySelector("input[type=radio]:checked")) return;
      if (campaign.querySelector("[data-gltheaa-novelty-select]")) return;

      const heading = campaign.querySelector(".novelty-gift__heading");
      const button = document.createElement("button");
      button.type = "button";
      button.className = "gltheaa-novelty-gift__select";
      button.dataset.gltheaaNoveltySelect = "true";
      button.textContent = selectLabel || heading?.textContent || "";
      if (heading) heading.hidden = true;
      options.forEach((option) => {
        option.hidden = true;
      });
      button.addEventListener("click", () => {
        if (heading) heading.hidden = false;
        options.forEach((option) => {
          option.hidden = false;
        });
        button.remove();
      });
      campaign.insertBefore(button, campaign.firstChild);
    });
  }

  function watchHost(el) {
    if (!(el instanceof HTMLElement) || el.dataset.gltheaaNoveltyWatched === "true") return;
    el.dataset.gltheaaNoveltyWatched = "true";
    new MutationObserver(() => {
      enhance(el);
    }).observe(el, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-busy", "data-visible"],
    });
  }

  function relocate() {
    const el = hostEl();
    if (!el) {
      syncNoveltyAddonVisibility();
      return;
    }
    watchHost(el);
    const slot = pickSlot();
    if (slot && el.parentElement !== slot) {
      slot.appendChild(el);
    } else if (!slot && el.parentElement !== parking()) {
      parking().appendChild(el);
    }
    enhance(el);
    syncNoveltyAddonVisibility();
  }

  new MutationObserver((mutations) => {
    let shouldRelocate = false;
    mutations.forEach((mutation) => {
      mutation.removedNodes.forEach((node) => {
        if (salvage(node)) shouldRelocate = true;
      });
      mutation.addedNodes.forEach((node) => {
        if (isHostOrContainsHost(node) || isSlotOrContainsSlot(node)) shouldRelocate = true;
      });
    });
    if (shouldRelocate) relocate();
  }).observe(document.documentElement, { childList: true, subtree: true });

  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    new MutationObserver(relocate).observe(drawer, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  document.addEventListener("shopify:cart:lines-update", () => {
    expandArmed = true;
    requestAnimationFrame(relocate);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", relocate);
  } else {
    relocate();
  }
})();
